import React, { useEffect, useState } from "react";
import Handler from "../../../Helpers/Components/Handler"
import Select from 'react-select'
import { useDispatch, useSelector } from "react-redux";
import { PhoneInput } from "react-international-phone";
import { setBooking, setPhone, setStep } from "../../../Reducer/bookingSlice";
import Modal from "../../../Helpers/Components/Modal";
import { setAccept, setCheckAccept } from "../../../Reducer/customerSlice";
import { toast } from "react-toastify";
import NextPrev from "../../../Helpers/Components/NextPrev"
import { useSearchParams } from "react-router-dom";

const Customer = () => {
    const [customerDetails, setCustomerDetails] = useState([])
    const [loading, setLoading] = useState(false)
    const [search, setSearch] = useState('a')
    const [newCust, setNewCust] = useState(false)
    const [searchParams] = useSearchParams();
    const name = searchParams.get("name");
    const number = searchParams.get("number");
    const booking = useSelector(state => state?.booking?.booking)
    const dispatch = useDispatch()
    const [disable, setDisable] = useState(false)
    const accept = useSelector((state) => state.customer?.accept)
    const checkAccept = useSelector((state) => state.customer?.checkAccept)
    const [open, setOpen] = useState(false);
    const validName = new RegExp('^[A-Za-z\\s]*$');
    const validPhoneNumber = new RegExp('^[6-9]{1}[0-9]{9}');
    const getCustomerDetails = async () => {
        const response = await Handler({ method: "post", url: `/customer/details/list/1?count=10`, data: { search: search || 'a', custStatus: true } })
        if (response?.success) {
            setCustomerDetails(response?.data?.current?.length ? response?.data?.current?.map((element, i) => { return { status: element?.status, label: (element?.firstName || "")?.toUpperCase() + (" ") + (element?.lastName || "")?.toUpperCase() + (" - ") + element?.customerId + (" - ") + (element?.phone?.length ? (element?.phone?.filter(element => element?.priority === 1)?.length ? ((element?.phone?.filter(element => element?.priority === 1)[0]?.code || "") + "-" + (element?.phone?.filter(element => element?.priority === 1)[0]?.phone || "")) : " ") : ""), value: element } }) : [])
        } else {
            setCustomerDetails([])
        }
    }
    const dlData = (booking?.customer?.kyc?.length ? booking?.customer?.kyc?.filter((element) => element?.type === "dl")?.length ? booking?.customer?.kyc?.filter((element) => element?.type === "dl")[0] : "-" : "-")
    const handlePhoneChange = (phone, code, i) => {
        dispatch(setPhone({ phone: phone || "", code: code || "+91" }))
    }
    const handlePaste = (e) => {
        e.preventDefault();
        let pasteData = e.clipboardData.getData('Text');
        pasteData = pasteData.replace(/\D/g, '').slice(0, 10);
        dispatch(setPhone({ phone: pasteData, code: e[0] || "+91" }))
    };
    const registerCustomer = async () => {
        if ((!booking?.firstName)) {
            toast.error("First Name is required");
        } 
        // else if ((!validName.test(booking?.firstName))) {
        //     toast.error("Invalid First Name");
        // } 
        else if (!booking?.lastName) {
            toast.error("Last name is required")
        } 
        // else if ((!validName.test(booking?.lastName))) {
        //     toast.error("Invalid Last Name");
        // } 
        else if (!booking?.phone?.phone) {
            toast.error("Phone number is required");
        } else if ((booking?.phone?.code === "+91" || booking?.phone?.code === "91") && !validPhoneNumber.test(booking?.phone?.phone)) {
            toast.error("Phone number is Invalid");
        } else {
            let dataToBeSent = {
                type: booking?.type || "Offline",
                custType: booking?.custType || "local",
                firstName: booking?.firstName,
                phone: [{ phone: booking?.phone?.phone, priority: 1, type: 'normal', code: booking?.phone?.code || "+91" }],
                lastName: booking?.lastName,
            }
            setLoading(true);
            // const response = await Handler({ method: "post", url: '/customer/check/number', data: { phone: booking?.phone?.phone } })
            // if (response?.success) {
            //     if (response?.data?.exist && !accept) {
            //         setLoading(false)
            //         setOpen(true)
            //     } else {
            dispatch(setAccept(true))
            const customerCreate = await Handler({ method: "post", url: '/customer/registration', data: dataToBeSent })
            setLoading(false)
            if (customerCreate?.success) {
                toast.success("Customer Registered Successfully")
                setDisable(true)
                dispatch(setBooking({ customerId: customerCreate?.data?.customerId }))
            } else {
                toast.error(customerCreate?.message)
            }
            // }
            // } else {
            //     setLoading(false)
            //     toast.error(response?.message)
            // }

        }
    }
    const handleChange = (e) => {
        dispatch(setBooking({ [e.target.name]: e.target.value }))
    }
    const handleNext = async () => {
        if (!booking?.customerId) {
            toast.error("Choose customer")
        } else {
            dispatch(setStep(1))
        }
    }
    const setSteps = () => {
        dispatch(setStep(1))
    }
    const customFormatOptionLabel = ({ label, status }) => (
        <div style={{ color: status ? 'black' : 'red' }}>
            {label}
        </div>
    );
    useEffect(() => {
        getCustomerDetails()
    }, [search])
    useEffect(() => {
        if (accept && checkAccept) {
            dispatch(setCheckAccept(false))
            registerCustomer()
        }
    }, [accept, checkAccept])
    const handleKeyUp = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            if (newCust) {
                registerCustomer()
            }
        }
    };
    useEffect(() => {
        if (name && number) {
            setNewCust(true)
        }
    }, [name, number])
    return (
        <React.Fragment>
            <div className="row">
                <div className="col-md-12 mb-3">
                    <button className="btn btn-danger btn-sm" onClick={() => { dispatch(setBooking({ customerId: "", firstName: "", lastName: "", phone: { phone: "", code: "" }, customer: "" })); setNewCust(!newCust) }}>{newCust ? "Existing Customer" : "New Customer"}</button>
                </div>
                {
                    // customer?.customerId ?
                    //     <>
                    //         <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    //             <div className="mb-3">
                    //                 <label htmlFor="dl" className="form-label"> First Name </label>
                    //                 <input readOnly className="text-uppercase" value={customer?.firstName || ""} />
                    //             </div>
                    //         </div>
                    //     </>
                    //     :
                    (newCust ?
                        <>
                            <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                                <div className="mb-3">
                                    <label htmlFor="firstName" className="form-label"> First Name </label>
                                    <input onChange={handleChange} onKeyUp={handleKeyUp} name="firstName" id="firstName" autoComplete="off" disabled={loading || disable} className="form-control input-theme text-uppercase" value={booking?.firstName || ""} />
                                </div>
                            </div>
                            <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                                <div className="mb-3">
                                    <label htmlFor="lastName" className="form-label"> Last Name </label>
                                    <input onChange={handleChange} onKeyUp={handleKeyUp} name="lastName" id="lastName" autoComplete="off" disabled={loading || disable} className="form-control input-theme text-uppercase" value={booking?.lastName || ""} />
                                </div>
                            </div>
                            <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                                <div className="mb-3">
                                    <label htmlFor="phone" className="form-label"> Mobile </label>
                                    <PhoneInput
                                        defaultCountry="in"
                                        onPaste={handlePaste}
                                        disabled={loading || disable} onKeyUp={handleKeyUp}
                                        value={booking?.phone?.phone ? booking?.phone?.code + booking?.phone?.phone : ""}
                                        onChange={(phone1, metadata) => {
                                            const code = `+${metadata.country.dialCode}`;
                                            const phone = phone1.replace(code, "").replace(/\s/g, "").replace(/-/g, "");
                                            handlePhoneChange(phone, code, 1)
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="text-center">
                                <button className="btn btn-sm btn-theme" disabled={loading || disable} onClick={() => registerCustomer()}>Register</button>
                            </div>
                        </>
                        :

                        <>
                            <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                                <div className="mb-3">
                                    <label htmlFor="dl" className="form-label"> Customer </label>
                                    <Select options={customerDetails} onInputChange={e => setSearch(e)} isDisabled={loading}
                                        styles={{
                                            control: (base, state) => ({
                                                ...base,
                                                borderColor: state.isFocused ? "#f16436" : base.borderColor,
                                                boxShadow: state.isFocused ? "0 0 0 1px #f16436" : "none",
                                                "&:hover": {
                                                    borderColor: "#f16436"
                                                }
                                            }),
                                            option: (style, state) => ({
                                                ...style,
                                                backgroundColor: state.isSelected
                                                    ? "#f16436"
                                                    : (state.isFocused || state.isActive)
                                                        ? "#f164361a"
                                                        : "white",
                                                color: state.isSelected ? "white" : "black"
                                            })
                                        }}
                                        value={booking?.customer?.customerId ? { status: booking?.customer?.status, label: (booking?.firstName || "")?.toUpperCase() + (" ") + (booking?.lastName || "")?.toUpperCase() + (" - ") + booking?.customerId + (" - ") + (booking?.customer?.phone?.length ? (booking?.customer?.phone?.filter(element => element?.priority === 1)?.length ? booking?.customer?.phone?.filter(element => element?.priority === 1)[0]?.phone : " ") : ""), value: booking?.customer } : ""}
                                        formatOptionLabel={customFormatOptionLabel} onChange={(e) => dispatch(setBooking({ customer: e.value, customerId: e?.value?.customerId, firstName: e?.value?.firstName, lastName: e?.value?.lastName, phone: { phone: (e?.value?.phone?.length ? (e?.value?.phone?.filter(element => element?.priority === 1)?.length ? e?.value?.phone?.filter(element => element?.priority === 1)[0]?.phone : " ") : ""), code: "+91" } }))} />
                                </div>
                            </div>
                            {
                                booking?.customer?.customerId ?
                                    <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                                        <div className="mb-3">
                                            <div className="text-capitalize">Status: {(booking?.customer?.status || "")} {booking?.customer?.status === "Verified" ? <i className="fa-solid fa-check-circle text-success"></i> : (booking?.customer?.status === "Unverified" ? <i className="fa-solid fa-circle-xmark text-danger"></i> : "")}</div>
                                            <div>Customer Remarks: {(booking?.customer?.remarks || "-")}</div>
                                            <div>DL: {dlData?.id || "-"}</div>
                                            <div>DL Valid Upto: {dlData?.detail?.validTo || ""} {dlData?.detail?.addresses && dlData?.detail?.validTo ? (new Date(dlData?.detail?.validTo) < new Date() ? <span className="text-danger fw-bold">Expired</span> : "") : (dlData?.detail?.validTo && dlData?.detail?.validTo?.split("/")?.length && new Date(dlData?.detail?.validTo?.split("/")[2], dlData?.detail?.validTo?.split("/")[1] - 1, dlData?.detail?.validTo?.split("/")[0]) < new Date() ? <span className="text-danger fw-bold">Expired</span> : "")} </div>
                                            <div>Phone: {(booking?.customer?.phone?.length ? (booking?.customer?.phone?.filter(element => element?.priority === 1)?.length ? ((booking?.customer?.phone?.filter(element => element?.priority === 1)[0]?.code || "") + "-" + (booking?.customer?.phone?.filter(element => element?.priority === 1)[0]?.phone || "")) : " ") : "")}</div>
                                        </div>
                                    </div>
                                    : ""
                            }

                        </>
                    )
                }
            </div>
            <NextPrev step={0} setStep={setSteps} last={2} onClick={handleNext} loading={loading} />
            <Modal header="Customer Already Exists in Customer Table" onShow={open} toggle={() => setOpen(false)} overlayToggle={() => setOpen(false)}>
                <div>Really Wanna add this customer ? </div>
                <div className="pt-4 pb-2 text-center">
                    <button className="btn btn-sm btn-success me-2" disabled={loading} onClick={() => { dispatch(setAccept(true)); setOpen(false); setCheckAccept(true) }}>Accept</button>
                    <button disabled={loading} className="btn btn-sm btn-danger" onClick={() => { dispatch(setAccept(false)); setOpen(false); }}>Reject</button>
                </div>
            </Modal>
        </React.Fragment>
    )
}

export default Customer;